import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type Response = {
  trainingSessionId: string
}

export function useCreateSession() {
  return useMutation({
    mutationFn: async (moduleId?: string) => {
      const { data } = await apiClient.post<Response>(`/int/v3/engagements/training/${moduleId}/sessions`)
      return data
    },
  })
}
